import { Dic } from './dictionary';

export { Dic, Dictionary } from './dictionary';
export { correctedHumanString } from './corrected-human-string';
export default Dic;
